export default {
    rtlLangs: ['ar', 'he', 'fa'], // Add rtlLangs property
}